var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmDelete16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#FE5B4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.7V9",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 11.1a.6.6 0 11-1.2 0 .6.6 0 011.2 0z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjciIGZpbGw9IiNGRTVCNEMiLz4KPHBhdGggZD0iTTggNC43MDAyVjkuMDAwMTgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC42MDAzOSAxMS4xQzguNjAwMzkgMTEuNDMxNCA4LjMzMTc2IDExLjcgOC4wMDAzOSAxMS43QzcuNjY5MDIgMTEuNyA3LjQwMDM5IDExLjQzMTQgNy40MDAzOSAxMS4xQzcuNDAwMzkgMTAuNzY4NiA3LjY2OTAyIDEwLjUgOC4wMDAzOSAxMC41QzguMzMxNzYgMTAuNSA4LjYwMDM5IDEwLjc2ODYgOC42MDAzOSAxMS4xWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgConfirmDelete16 as ReactComponent };